import React from 'react';
import { Asset, CloseIcon } from '@clearcover/atlas';

import { Modal } from 'Shared/components';
import { FeeStrategyPicker } from 'QuoteApp/components';

import { FeeStratetySelectorModalPropsType } from './types';
import styles from './styles.module.css';

export const FeeStratetySelectorModal: React.FC<
  FeeStratetySelectorModalPropsType
> = ({
  title,
  showModal,
  selectedStrategy,
  strategies,
  isLoading,
  closeModal,
  onStrategySelect,
}) => {
  const renderModalHeader = () => (
    <div className={styles.header}>
      <h2 className={styles.modalTitle}>{title}</h2>
      <button type="button" className={styles.close} onClick={closeModal}>
        <Asset
          icon={CloseIcon}
          description="Close strategy picker"
          height={14}
          width={14}
        />
      </button>
    </div>
  );

  const renderStrategyPicker = () => (
    <FeeStrategyPicker
      strategies={strategies}
      selectedStrategy={selectedStrategy}
      isLoading={isLoading}
      onStrategySelect={onStrategySelect}
      onContinue={closeModal}
    />
  );

  return (
    <Modal className={styles.modal} showModal={showModal} disableCurtainClick>
      <div className={styles.modalContent}>
        {renderModalHeader()}
        {renderStrategyPicker()}
      </div>
    </Modal>
  );
};
